import { render, staticRenderFns } from "./ResortCom.vue?vue&type=template&id=7cc80a1b&scoped=true"
import script from "./ResortCom.vue?vue&type=script&lang=js"
export * from "./ResortCom.vue?vue&type=script&lang=js"
import style0 from "./ResortCom.vue?vue&type=style&index=0&id=7cc80a1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc80a1b",
  null
  
)

export default component.exports